import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { config } from "../../../config";

const imageUrl = config.imageUrl;

const UpdateAboutPage = ({
  formData,
  handleChange,
  handleSubmit,
  setPhoto,
  handleQuillParagraph,
  handleQuillImageParagraph,
  handleQuillBottomParagraph,
  loading,
  error,
}) => {


  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update About Page</h2>

      {loading && <p className="text-blue-500 mb-4">Updating About Page...</p>}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Headline */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter headline"
            required
          />
        </div>

        {/* Paragraph */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Paragraph</label>
          <ReactQuill
            value={formData.paragraph}
            onChange={handleQuillParagraph}
            className="border w-full"
            theme="snow"
          />
        </div>

        {/* Image Upload */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Image</label>
          {formData.image && (
            <img src={`${imageUrl}/${formData.image}`} alt="" height={200} width={200} />
          )}
          <input
            type="file"
            name="image"
            onChange={(e) => setPhoto(e.target.files[0])}
            className="border w-full p-2"
          />
        </div>

        {/* Image Paragraph */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Image Paragraph</label>
          <ReactQuill
            value={formData.imageParagraph}
            onChange={handleQuillImageParagraph}
            className="border w-full p-2"
            placeholder="Enter image paragraph"
          />
        </div>

        {/* Bottom Paragraph */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Bottom Paragraph</label>
          <ReactQuill
            value={formData.bottomParagraph}
            onChange={handleQuillBottomParagraph}
            className="border w-full p-2"
            placeholder="Enter bottom paragraph"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? "Updating..." : "Update About Page"}
        </button>
      </form>
    </div>
  );
};

export default UpdateAboutPage;
